module.exports = __webpack_public_path__ + "img/print-food-runner-chit.deab3a85.svg";